export interface ModuleColumn { key: string; label: string; width: number | null; frozen?: boolean; dateOnly?: boolean; /** Optional cell alignment from ModuleColumn.Align (e.g. 'right' for a numeric ID). */ align?: string | null; /** ModuleColumn.Currency — show a number as G5 money ($1,050.00); display only. */ currency?: boolean; }

export interface ModuleResponse {
  success: boolean;
  module: {
    key: string;
    title: string;
    mapped: boolean;
    hasDateRange: boolean;
    columns: ModuleColumn[];
  };
  data: Record<string, unknown>[];
  meta: { page: number; pageSize: number; totalCount: number; totalPages: number };
}

/** One advanced "Query" builder condition (ALPACA's Query button). */
export interface QueryCondition { col: string; op: QueryOp; val: string; }
export type QueryOp = 'eq' | 'neq' | 'contains' | 'startswith' | 'endswith';

export interface ModuleParams {
  page: number;
  pageSize: number;
  search: string;
  rangeDays: number | null;
  filters: Record<string, string[]>;
  sort?: string | null;
  sortDesc?: boolean;
  // Custom From/To date range (yyyy-MM-dd). When set, overrides rangeDays.
  fromDate?: string | null;
  toDate?: string | null;
  // Advanced "Query" builder conditions (AND-combined).
  conditions?: QueryCondition[];
  // "Query Samples" dialog — Date Analyzed + Date Collected ranges (yyyy-MM-dd).
  analysisFrom?: string | null;
  analysisTo?: string | null;
  collectedFrom?: string | null;
  collectedTo?: string | null;
  /** Single-value Category chip (Test Code). '(none)' = Uncategorized. */
  category?: string | null;
}

export const F_BLANKS = '__BLANKS__';
export const F_NONBLANK = '__NONBLANK__';
/**
 * "Uncheck all" sentinel. A value the data never contains, so the server's
 * `col IN (...)` matches zero rows. Lets a column filter express "show none"
 * (Excel-style uncheck-all) — an empty list means "no filter / show all",
 * which is a different state.
 */
export const F_NONE = '__NONE__';
